import React, { FC } from 'react';
import styled from 'styled-components';
import CallToActionLink, {
  CallToActionLinkProps,
} from '../../components/CallToActionLink';

export type CallToActionProps = CallToActionLinkProps & {
  link: string;
  title: string;
};

const StyledCallToActionLink = styled(CallToActionLink)`
  margin: 0;
`;

const CallToAction: FC<CallToActionProps> = ({ link, title, ...props }) => {
  return (
    <StyledCallToActionLink {...props} size="md" href={link} target="_blank">
      {title}
    </StyledCallToActionLink>
  );
};

export default CallToAction;
